import ApiService from './api.service';

class ComparadorPreciosService extends ApiService {
  constructor() {
    super('/productos/comparador-precios');
  }

  async consultar(payload) {
    const res = await this.post('/consultar', payload);
    if (res.status >= 400) {
      throw new Error(res.data?.message || 'No se pudo comparar');
    }
    return res.data?.data;
  }
}

const comparadorPreciosService = new ComparadorPreciosService();
export default comparadorPreciosService;
